/* @flow */

export default class SubmitFlexInvoiceRequest {
  invoiceId: number;
  requiresToPay: boolean;

  constructor(invoiceId: number, requiresToPay: boolean) {
    this.invoiceId = invoiceId;
    this.requiresToPay = requiresToPay;
  }
}
